module.exports = __webpack_public_path__ + "assets/img/logo.56574cde.png";